import { CarComparisonStore } from 'components/driving/store'
import { isComparisonResults } from 'utils/page'
import { ComparisonResults } from 'components/driving'
import {
    IDrivingStore,
    IDrivingVehicle
} from 'components/driving/driving-interface'

/**
 * Indicate radio button in the trim selector modal
 *
 * @returns {boolean}
 */
export const isRadioButton = (): boolean => {
    if (isComparisonResults() && !isMyPicksPage()) {
        return true
    }
    return false
}

/**
 * Indicate my picks page on comparison result page
 *
 * @returns {boolean}
 */
export const isMyPicksPage = (): boolean => {
    if (vehicleIdsInMyPicks() !== vehicleIdsInUrl()) {
        return false
    }
    return true
}

/**
 * Get vehicle ids from my picks result page url
 *
 * @returns {string}
 */
export const vehicleIdsInMyPicks = (): string => {
    const vehicles = CarComparisonStore.getInstance().get()
    const vehicleIds = vehicles.map((vehicle) => vehicle.id)

    if (vehicleIds.length > 0) {
        return vehicleIds.sort().toString()
    } else {
        return ''
    }
}

/**
 * Get vehicle ids from comparison result page url
 *
 * @returns {string}
 */
export const vehicleIdsInUrl = (): string => {
    const currentUrl: URL = new URL(window.location.href)
    return (
        currentUrl.pathname
            .split('/')[2]
            .split('-')
            .sort()
            .toString() || ''
    )
}

/**
 * Build comparison results full url path based on vehicles data
 *
 * @returns {string}
 */
export const getResultsUrlPath = (
    vehicles: (IDrivingVehicle | undefined)[]
): string => {
    const defaultPath = ComparisonResults.pageUrl
    if (vehicles.length) {
        const idPath = vehicles
            .map((vehicle: IDrivingVehicle) => {
                if (!vehicle) {
                    return undefined
                }
                return vehicle.id
            })
            .filter((id) => id)
            .join('-')
        const namePath = vehicles
            .map((vehicle: IDrivingVehicle) => {
                if (!vehicle) {
                    return undefined
                }
                if (vehicle.slugified_name === '-') {
                    vehicle.slugified_name = 'base-trim'
                }
                return `${vehicle.slugified_full_model_name}-${vehicle.slugified_name}`
            })
            .filter((name) => name)
            .join('-vs-')
        if (idPath && namePath) {
            return `${defaultPath}/${idPath}/${namePath}`
        }
    }
    return `${defaultPath}/`
}

/**
 * Indicate if the vehicle is in my picks session
 *
 * @param {IDrivingStore<IDrivingVehicle>} vehicles
 * @param {string} id
 * @returns {boolean}
 */
export const isVehicleInMyPicks = (
    vehicles: IDrivingStore<IDrivingVehicle>[],
    id: string
): boolean => {
    const onMyPicks = vehicles
        .filter((obj) => obj.id === parseInt(id))
        .map((filtered) => filtered.id)

    if (onMyPicks.length) {
        return true
    }
    return false
}
